import React from 'react';
import { motion } from 'framer-motion';
import useScrollAnimation from '../../hooks/useScrollAnimation';
import { FiMonitor, FiTruck, FiHeart } from 'react-icons/fi';
import { BiAtom, BiDumbbell, BiFoodMenu, BiLibrary } from 'react-icons/bi';

const facilities = [
  { icon: FiMonitor,  title: 'Smart Classrooms', description: 'Interactive whiteboards and digital learning tools in every classroom.',           color: 'bg-primary-50 text-primary-600 border-primary-100'     },
  { icon: BiAtom,     title: 'Science Labs',     description: 'Well-equipped Physics, Chemistry, and Biology laboratories for hands-on learning.',  color: 'bg-secondary-50 text-secondary-600 border-secondary-100'},
  { icon: FiMonitor,  title: 'Computer Lab',     description: 'Modern computer lab with high-speed internet for digital literacy.',                 color: 'bg-blue-50 text-blue-600 border-blue-100'               },
  { icon: BiLibrary,  title: 'Library',          description: 'Extensive collection of books, journals, and digital resources.',                    color: 'bg-primary-50 text-primary-700 border-primary-100'      },
  { icon: BiDumbbell, title: 'Sports Complex',   description: 'Multi-sport facilities including basketball, volleyball, and athletics track.',      color: 'bg-secondary-50 text-secondary-700 border-secondary-100'},
  { icon: FiTruck,    title: 'Transportation',   description: 'Safe and reliable school bus services covering all major routes.',                   color: 'bg-indigo-50 text-indigo-600 border-indigo-100'          },
  { icon: BiFoodMenu, title: 'Cafeteria',        description: 'Hygienic cafeteria serving nutritious meals and healthy snacks.',                    color: 'bg-orange-50 text-orange-600 border-orange-100'          },
  { icon: FiHeart,    title: 'Medical Room',     description: 'On-campus medical facility with trained nurse and first aid support.',               color: 'bg-pink-50 text-pink-600 border-pink-100'                },
];

export default function FacilitiesSection() {
  const { ref, isVisible } = useScrollAnimation();
  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 20 }}
          animate={isVisible ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-10 sm:mb-14"
        >
          <p className="section-subtitle mb-2">World-Class Facilities</p>
          <h2 className="section-title mb-4">State-of-the-Art Infrastructure</h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-sm sm:text-base">
            We provide excellent facilities to create an optimal learning environment
            that supports academic and personal growth.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4 lg:gap-5">
          {facilities.map((facility, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, scale: 0.92 }}
              animate={isVisible ? { opacity: 1, scale: 1 } : {}}
              transition={{ duration: 0.45, delay: idx * 0.07 }}
              className="bg-white border border-gray-100 rounded-2xl p-4 sm:p-5 group card-hover cursor-default shadow-sm"
            >
              <div className={`w-10 h-10 sm:w-12 sm:h-12 rounded-xl flex items-center justify-center mb-3 sm:mb-4 border group-hover:scale-110 transition-transform ${facility.color}`}>
                <facility.icon className="w-5 h-5 sm:w-6 sm:h-6" />
              </div>
              <h3 className="font-bold text-gray-800 text-xs sm:text-sm mb-1.5 sm:mb-2">{facility.title}</h3>
              <p className="text-gray-400 text-xs leading-relaxed hidden sm:block">{facility.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
